var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center text-center",class:`py-${_vm.py}`},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":_vm.color,"indeterminate":""}}),(_vm.label)?_c('div',{staticClass:"mt-6 neutral8--text text-body-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }